import React from 'react';
import { Row, Col, Typography, Divider, Image } from 'antd';
import SatelliteImage from '../../Assets/About/About-NCGSA-Globe.png';
import '../../Styles/AboutStyles.css'; // Create a CSS file for the styles

const { Title, Paragraph } = Typography;
const NCGSAComponent = () => {
  return (
    <section className="ncgsa-section">
      <Row gutter={[64, 40]} justify="space-between" align="middle">
        {/* Text Section */}
        <Col xs={24} md={14}>
          <Title level={2} className="ncgsa-title">NCGSA</Title>
<Divider className="ncgsa-divider-title" />
          <Paragraph className="ncgsa-text">
            The emerging demand of GIS and Space Applications for the socio-economic
            development of Pakistan impelled the HEC to develop the National Center of GIS
            and Space Applications in addition to the already established four national centers,
            namely the National Center on Artificial Intelligence, Big Data and Cloud Computing,
            Robotics and Automation, and Cyber Security.
          </Paragraph>
          <Paragraph className="ncgsa-text">
            The centers envisaged the development in futuristic areas that are of strategic national
            importance, economic benefit, creation of knowledge economy, and scientific leadership.
            In this regard HEC proposed the establishment of the National Centre of GIS & Space Applications.
          </Paragraph>
        </Col>

        {/* Image Section */}
        <Col xs={24} md={10} className="ncgsa-image-container">
          <Image
            preview={false}
            src={SatelliteImage}
            alt="Connected globe representing GIS and space applications"
            className="ncgsa-image"
          />
        </Col>
      </Row>
    </section>
  );
};

export default NCGSAComponent;
